import { useState, useCallback, useEffect } from "react";
import { useAuthenticatedApi } from "./useAuthenticatedApi";
import { getMessageTypes } from "../api/messagesApi";
import { MessageType } from "../api/messages";

export const useMessageTypes = () => {
  const { callApi } = useAuthenticatedApi();
  const [messageTypes, setMessageTypes] = useState<MessageType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchMessageTypes = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const types = await getMessageTypes(callApi);
      setMessageTypes(types);
    } catch (err) {
      const errorObj =
        err instanceof Error ? err : new Error("Failed to load message types");
      setError(errorObj);
    } finally {
      setIsLoading(false);
    }
  }, [callApi]);

  // Auto-fetch on mount
  useEffect(() => {
    fetchMessageTypes();
  }, [fetchMessageTypes]);

  return {
    messageTypes,
    isLoadingMessageTypes: isLoading,
    messageTypeError: error,
    fetchMessageTypes,
  };
};
